/**
 * Mimic the Storage interface. This makes Foundation.Storable.Bucket's life
 * easier when running in IE7 or if the user has Web Storage disabled.
 * @constructor
 */
Foundation.Storable.WebStorageEmulator = function () {
  /**
   * @private
   * @type {Object.<string,string>}
   */
  this._data = {};

  /**
   * @public
   * @type {number}
   */
  this.length = 0;

  /**
   * @private
   * @type {Array.<string>}
   */
  this._keysCache = null;
};

/**
 * @param {string} key
 * @return {string?}
 */
Foundation.Storable.WebStorageEmulator.prototype.getItem = function (key) {
  var item = this._data[key];

  if (item === undefined) {
    item = null;
  }

  return item;
};

/**
 * @param {string} key
 * @param {*} val
 */
Foundation.Storable.WebStorageEmulator.prototype.setItem = function (key, val) {
  if (!this._data.hasOwnProperty(key)) {
    this.length += 1;
  }

  this._data[key] = `${val}`;
  this._keysCache = null;
};

/**
 * @param {string} key
 */
Foundation.Storable.WebStorageEmulator.prototype.removeItem = function (key) {
  this.length -= 1;
  delete this._data[key];
  this._keysCache = null;
};

/**
 * @param {number} n
 * @return {string}
 */
Foundation.Storable.WebStorageEmulator.prototype.key = function (n) {
  // Populate our keys cache.
  if (!this._keysCache) {
    this._keysCache = [];
    Foundation.each(this._data, function (item, i, key) {
      this._keysCache.push(key);
    }.bind(this));
  }

  return this._keysCache[n];
};
